import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';

export const fireCoreInvitesInJsmProjectFeatureExposed = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	coreInvitesJsmExpValue: string,
) => {
	fireTrackAnalytics(createAnalyticsEvent({}), 'feature exposed', {
		flagKey: 'jsm_core_invites_experiment',
		cohort: coreInvitesJsmExpValue,
	});
};
